<template>
  <div id="app" class="row vert-offset-top-1">
    <div class="row justify-content-center">
      <div class="col s12 m10 l8 offset-m1 offset-l2">
        <div id="card" class="card col s12 vert-offset-top-1 z-depth-3">
          <div
            class="card-title center padding-top-half padding-bottom-half border-bottom-1 grey-border border-lighten-2"
          >
            <h5 class="grey-text text-darken-3">
              Additonal Information
            </h5>
            <div class="row vert-offset-top-half vert-offset-bottom-half">
              <div class="s12 padding-bottom-1 padding-top-1">
                <div class="s12 padding-bottom-1 padding-top-1 m12">
                  <form class="col s9 offset-s2 ">
                    <div class="col  s12 ">
                      <text-area-component
                        v-model="info"
                        id="summary"
                        label="Add more info here.."
                      ></text-area-component>
                    </div>
                  </form>
                </div>
              </div>
              <div class="col s4 offset-s4 padding-bottom-1 padding-top-1">
                <button
                  type="submit"
                  @click="goto"
                  class="btn btn-small deep-orange darken-2 white-text col s12"
                >
                  continue
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TextAreaComponent from "@/components/materiallize/TextAreaComponent";

export default {
  name: "Book",
  components: {
    TextAreaComponent
  },
  data() {
    return {
      districts: [],
      items: [],
      info: "",
      timer: 10,
      submit_booking: false
    };
  },
  methods: {
    goto() {
      this.$store.dispatch("SET_INFO", this.info);
      this.$router.push("/book");
    }
  },
  computed: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style></style>
